import React from "react";
import { Box, Flex } from "@chakra-ui/react";

interface Props {
  leftSideComponent: React.ReactNode;
  rightSideComponent: React.ReactNode;
}

function SettlementManagementLayout({
  leftSideComponent,
  rightSideComponent,
}: Props) {
  return (
    <Box padding={"16px"} height={"100%"}>
      <Flex
        background={"#FFFFFF"}
        height={"100%"}
        borderRadius={"8px"}
        boxShadow={"0 0 0 0.5px #D4D4D1"}
        minWidth={"1136px"}
      >
        <Flex
          flexDirection={"column"}
          gap={"16px"}
          width={"344px"}
          boxShadow={"0.5px 0 0 0 #D4D4D1"}
          minWidth={"300px"}
        >
          {leftSideComponent}
        </Flex>
        <Flex flexDirection={"column"} gap={"16px"} flex={1} minWidth={"800px"}>
          {rightSideComponent}
        </Flex>
      </Flex>
    </Box>
  );
}

export default SettlementManagementLayout;
